import { render, staticRenderFns } from "./BlockHighlightWithImage.vue?vue&type=template&id=738e1f81&"
import script from "./BlockHighlightWithImage.vue?vue&type=script&lang=js&"
export * from "./BlockHighlightWithImage.vue?vue&type=script&lang=js&"
import style0 from "./BlockHighlightWithImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports